var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoReserva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.11 12.765H21.95C22.28 12.765 22.505 13.095 22.3925 13.4025C21.8975 14.715 20.4275 16.6425 17.03 16.6425C13.6325 16.6425 12.1625 14.715 11.6675 13.4025C11.5475 13.095 11.78 12.765 12.11 12.765Z",
    fill: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9926 11.6475C18.3719 11.6475 19.4901 10.5293 19.4901 9.14997C19.4901 7.77063 18.3719 6.65247 16.9926 6.65247C15.6133 6.65247 14.4951 7.77063 14.4951 9.14997C14.4951 10.5293 15.6133 11.6475 16.9926 11.6475Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41745 13.905H17.3524C17.8174 13.905 18.1399 14.37 17.9749 14.8125C17.2774 16.6725 15.1924 19.395 10.3849 19.395C5.57745 19.395 3.49245 16.665 2.79495 14.805C2.62995 14.37 2.95245 13.8975 3.41745 13.8975V13.905Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.325 12.315C12.2759 12.315 13.8575 10.7334 13.8575 8.7825C13.8575 6.83155 12.2759 5.25 10.325 5.25C8.37404 5.25 6.79248 6.83155 6.79248 8.7825C6.79248 10.7334 8.37404 12.315 10.325 12.315Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoReserva);
export default __webpack_public_path__ + "static/media/Ico_reserva.5bf315f18b1f4d200b9c40c8ffc21990.svg";
export { ForwardRef as ReactComponent };